import React, { Component } from 'react'

import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import withTour from '../../../components/hocs/withTour'
import BlankCard from '../../../components/ui/cards/BlankCard'
import SearchHistoryPanel from '../../../components/ui/SearchHistory/SearchHistoryPanel/SearchHistoryPanel'
import PageTitle from '../../../components/ui/typography/PageTitle'
import selectors from '../../../store/shared/selectors'
import withJobSearch from '../../../utils/graphql/hocs/withJobSearch'
import intercom from '../../../utils/intercom/intercomUtils'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'

import JobSearchFiltersForm from './components/JobSearchFiltersForm'
import SavedJobsWrapper from './components/SavedJobs/SavedJobsWrapper'
import * as jobSearchDuck from './jobSearchDuck'
import * as savedJobsDuck from './savedJobsDuck'
import EndOfList from './components/EndOfList'
import { performSaveJobSearch } from '../../../components/ui/SearchHistory/searchHistoryDuck'
import uberFacts from '../../../assets/usageTips/tips.json'
import LottieLoader from '../../../components/ui/lotties/LottieLoader'
import JobPostingDetail from './components/JobPostingDetail'
import JobPostingListItem from './components/JobPostingListItem'

class AuthenticatedJobSearchIndex extends Component {
  static propTypes = {
    formValues: PropTypes.any.isRequired,
    isEmptyData: PropTypes.bool.isRequired,
    isRequestingJobs: PropTypes.bool.isRequired,
    jobs: PropTypes.array.isRequired,
    pagination: PropTypes.any.isRequired,
    payFilter: PropTypes.any,
    performDeleteSavedJob: PropTypes.func.isRequired,
    performJobSearch: PropTypes.func.isRequired,
    performRetrieveSavedJobs: PropTypes.func.isRequired,
    performSaveJob: PropTypes.func.isRequired,
    queryParams: PropTypes.any.isRequired,
    savedJobs: PropTypes.array,
    searchError: PropTypes.string,
    userId: PropTypes.string,
    getJobPostings: PropTypes.func,
    jobPostings: PropTypes.arrayOf(PropTypes.object),
  }

  constructor(props) {
    super(props)

    this.state = {
      initialFormValues: null,
    }

    this.search = params => {
      this.props.performJobSearch(params)
    }

    this.onSubmit = event => {
      event && event.preventDefault && event.preventDefault()
      this.props.getJobPostings(this.props.formValues)
      this.props.performSaveJobSearch(this.props.formValues)
    }

    this.loadMoreResults = () => {
      this.props.getNextBatchOfJobPostings(this.props.formValues)
    }

    this.saveJob = params => {
      this.props
        .performSaveJob(params)
        .then(() => {
          notificationsUtils.showSuccessNotification('Job Saved Successfully!')
          this.props.performRetrieveSavedJobs({
            user_id: this.props.userId,
          })
        })
        .catch(() => {})
    }

    this.turnQueryParamsIntoFormValues = params => {
      const { keywords, location, radius, workFromHome } = params
      const stringToBool = string => (string === 'true' ? true : false)

      /**
       * @type {import('../../../utils/graphql/hocs/withJobSearch').JobSearchParams}
       */
      const variables = {
        searchTerm: keywords,
        page: 0,
      }
      if (location) variables.location = location
      if (radius && location && radius.length) variables.radius = parseInt(radius, 10)
      if (workFromHome) variables.workFromHome = stringToBool(workFromHome)

      return variables
    }

    this.checkQueryParams = queryParams => {
      if (!queryParams || !queryParams.keywords) return

      const initialFormValues = this.turnQueryParamsIntoFormValues(queryParams)

      this.setState({ initialFormValues }, () => {
        this.props.getJobPostings(initialFormValues)
      })
    }
  }

  componentWillMount() {
    const { userId, performRetrieveSavedJobs } = this.props
    performRetrieveSavedJobs({ user_id: userId })
  }

  componentDidMount() {
    const { queryParams } = this.props
    this.checkQueryParams(queryParams)

    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
  }

  render() {
    const {
      isEmptyData,
      isRequestingJobs,
      payFilter,
      performDeleteSavedJob,
      queryParams,
      savedJobs,
      noResults,
      jobPostings,
      loadingJobPostings,
      noMorePagesToLoad,
      error,
    } = this.props

    return (
      <div>
        <div className="main-page">
          <JobPostingDetail />
          <div>
            <PageTitle content="Job Search" showHistoryBtn tourName="jobSearch" />
            <div className="row">
              <div className="col-xl-10 offset-xl-1">
                <JobSearchFiltersForm
                  initialValues={this.state.initialFormValues}
                  enableReinitialize={queryParams && get(queryParams, 'searchTerm')}
                  isEmptyData={isEmptyData}
                  isLoading={isRequestingJobs}
                  onSubmit={this.onSubmit}
                  payFilter={payFilter}
                />

                <div style={{ marginTop: 10, marginBottom: 10 }}>
                  <BlankCard notCard delay={0.5}>
                    <div className="list-group shadow">
                      {jobPostings.map((jobPosting, i) => {
                        const isLastPost = i === jobPostings.length - 1
                        const isFirstPost = i === 0
                        return (
                          <JobPostingListItem
                            onSelectJobTitle={this.props.selectJobTitle}
                            key={jobPosting.job_id}
                            jobPosting={jobPosting}
                            onSave={this.saveJob}
                            isLastPost={isLastPost}
                            isFirstPost={isFirstPost}
                          />
                        )
                      })}
                    </div>
                    <LottieLoader
                      animationName="GEARS"
                      isReady={!loadingJobPostings}
                      loadingTime={loadingJobPostings ? 1000 : 0}
                      noData={!loadingJobPostings && noResults}
                      error={error}
                      uberFacts={uberFacts}
                      noMessage
                      height={500}
                      width={300}
                      loadingLottieDivMarginTop={-120}
                    >
                      <EndOfList
                        loadedCount={jobPostings.length}
                        noMorePagesToLoad={noMorePagesToLoad}
                        loading={loadingJobPostings}
                        handleClick={this.loadMoreResults}
                      />
                    </LottieLoader>
                  </BlankCard>
                </div>
              </div>
            </div>
            <SearchHistoryPanel searchFilter="Jobs">
              <SavedJobsWrapper savedJobs={savedJobs} onDelete={performDeleteSavedJob} />
            </SearchHistoryPanel>
          </div>
        </div>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const isPerformingJobSearch = selectors.makeGetIsPerformingRequest()
  const getJobSearchFiltersFormValues = selectors.makeGetFormValues()
  return state => ({
    isEmptyData: jobSearchDuck.getIsEmptyData(state),
    isRequestingJobs: isPerformingJobSearch(state, 'jobSearch'),
    jobs: jobSearchDuck.getJobs(state),
    pagination: state.jobSearch.pagination,
    formValues: getJobSearchFiltersFormValues(state.form.jobSearchFiltersForm),
    queryParams: selectors.getQueryStringObject(state),
    searchError: selectors.getErrorFromReduxBranch(state, 'jobSearch'),
    payFilter: state.jobSearch.payFilter,
    savedJobs: savedJobsDuck.getSavedJobs(state),
    userId: selectors.getUserId(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performDeleteSavedJob: savedJobsDuck.performDeleteSavedJob,
      performJobSearch: jobSearchDuck.performJobsSearch,
      performRetrieveSavedJobs: savedJobsDuck.performRetrieveSavedJobs,
      performSaveJob: savedJobsDuck.performSaveJob,
      performSaveJobSearch: performSaveJobSearch,
      toggleJobDetailsModal: jobSearchDuck.toggleJobDetailsModal,
      selectJobTitle: jobSearchDuck.selectJobTitle,
    },
    dispatch,
  )

// Tour Steps
const tourSteps = [
  {
    selector: '#jobSearch',
    content: "Search the live job market to see who's hiring in your industry.",
  },
]

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(withTour('jobSearch', tourSteps)(withJobSearch(AuthenticatedJobSearchIndex)))



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/AuthenticatedJobSearchIndex.js